export default "__VITE_ASSET__BzlVlfOy__"